import React from 'react';
import { bem, getDataAttr } from '../_libs/utils';
import { Component, PropTypes } from '../_libs';
import './style/index.scss';

export default class Icon extends Component {
  svgLoader(svg) {
    const icon = typeof svg === 'string' ? svg.replace('#', '') : svg.default.id;
    return {
      iconName: icon,
      xlinkHref: `#${icon}`,
    };
  }
  /*renderSvg() {
    let svg;
    const iconName = this.props.icon;
    try {
      if (iconName) {
        svg = require(`./assets/${iconName}.svg`);// eslint-disable-line
      }
    } catch (e) {
      console.error('svg require err: ', e);
    } finally {
      return svg;// eslint-disable-line no-unsafe-finally
    }
  }*/
  render() {
    const displayName = 'icon';
    const { icon, type, isAuto, isBackground } = this.props;
    // let xlinkHref;
    let iconName = icon;
    /* isBackground 默认是true，好像也没有引入，上述renderSvg会导致assets都引入进来，这里就注释掉 ,检查之前又没用到background则是安全改动
    // 非背景模式下使用svg内联模式
    if (!isBackground) {
      if (typeof icon === 'string') {
        if (icon.indexOf('#') !== -1) {
          // 旧版svg-sprite-loader
          xlinkHref = icon;
          iconName = icon.replace('#', '');
        } else {
          // 使用图标库
          xlinkHref = this.svgLoader(this.renderSvg()).xlinkHref;
        }
      } else {
        // 使用外部图标
        const svgLoader = this.svgLoader(icon);
        xlinkHref = svgLoader.xlinkHref;
        iconName = svgLoader.iconName;
      }
      if (!xlinkHref) {
        console.warn(`没有找到图标${iconName}`);
      }
    }*/
    const stateCls = {
      'is-auto': isAuto,
      // 'is-svg': !isBackground,
      [bem(displayName, '', type)]: type !== '',
      [bem(displayName, '', iconName)]: true,
    };
    return (
      <i
        className={this.className(bem(displayName), stateCls)}
        style={this.style()}
        {...getDataAttr(this.props)}
      >
        {/*{!isBackground ? (
          <svg>
            <use xlinkHref={xlinkHref} />
          </svg>
        ) : null}*/}
      </i>
    );
  }
}

Icon.defaultProps = {
  icon: 'audio',
  type: '',
  isAuto: false,
  isBackground: true,
};

Icon.propTypes = {
  // @INTRO 设置图标组件 使用的icon, 对应的svg文件放入assets
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // @INTRO 设置从assets中拿到的图标，require(./assets/xxx.svg)
  type: PropTypes.object,
  // @INTRO 是否跟随字号大小
  isAuto: PropTypes.bool,
  // @DEPRECATED @INTRO 是否使用背景模式(无图模式下背景模式会无效)
  isBackground: PropTypes.bool,
};
